<script>
import config from "@/helpers/config"
import niceFunctions from "@/helpers/niceFunctions"
import SvgTransition from '@/components/SvgTransition.vue'
export default {
    components: { SvgTransition },
    data() {
        return {
            
        }
    },
    created() {  
        this.$cache.createCache('publicPage', 'public-page/',  {id: this.$route.params.id, domain: window.location.hostname });  
       
    },
    computed: {
        url() { return config.urlToServer },  
        publicPageColorsDict() { return this.$store.state.publicPage != null ?  this.$store.state.publicPage.publicPageColorsDict : null },         
        publicPage() { return this.$store.state.publicPage != null ?  this.$store.state.publicPage.publicPage : null },
        height() { return window.innerHeight/1.14 + 'px' },
        instructors() { return this.$store.state.publicPage != null ?  this.$store.state.publicPage.instructors : [] },
        settings() { return this.$store.state.publicPage != null ?  this.$store.state.publicPage.settings : null },
        hasSettings() { return this.settings != null },
    },
    methods:
    {
        goTopage(item)
        {
            $(window).scrollTop(0);           
            this.$router.push({ name: niceFunctions.getPageName('instructorDetails'), params: { id: this.$route.params.id, instructorid: item.id } })
        } ,
        blurOut(item)
        {
            if(this.instructors.filter(x => x.hovered) == 0) {
                return false;
            }
            else if(item.hovered) {
                return false;
            }
            return true;
        }       
    }   
}
</script>
<template>
   <section  class="public-page" v-if="publicPage != null && settings != null">   
        <div class="text-section" style="padding-top: 70px;min-height: 1000px">
            <h1 :style="publicPageColorsDict.header_color_on_white_bg.style" class="margin-top-70">{{ settings.CourseInstructor.plural }}</h1>     
            <div class="Instructors-wrapper">
                <div v-for="instructor in instructors" class="Instructors-course-item"> 
                    <div @mouseover="instructor.hovered = true" @mouseout="instructor.hovered = false" :class="blurOut(instructor) ? 'ImageGallery-grayscale' : 'ImageGallery-no-grayscale'" >
                        <div class="position-relative">
                            <div class="Instructors-course-img-area">
                                <img v-if="instructor.image_id" :src="url + 'uploads/'+ publicPage.customer_id+'/images/thumbnails/'+ instructor.image_name" />  
                                <i v-else class="fa-regular fa-image wow-color wow-color-bg"></i>
                            </div>
                            <h4 :style="{'background-color': publicPageColorsDict.background_color.color }">{{ instructor.name }}</h4>
                        </div>
                        <div class="Instructors-course-max-booking">
                            <i><span v-html="instructor.description.length > 200 ? instructor.description.slice(0, 200) + '...' : instructor.description"></span></i>
                            
                            <button class="Instructors-btn float-right margin-top-15" :style="{'background-color': publicPageColorsDict.background_color.color }" @click="goTopage(instructor)">Läs mer och se kurser</button>
                        </div>
                    </div>              
                </div>    
            </div>              
        </div>
   </section>
</template>
<style scoped>
    .Instructors-btn{
        background-color: rgb(181, 205, 191);
    padding: 10px 20px;
    font-size: 21px;
    color: black;
    border: 0px solid lightgray;
    font-family: 'Raleway', sans-serif;
    -webkit-font-smoothing: antialiased;
    font-weight: 700;
    cursor: pointer;
    }
    
    .Instructors-filter-section {     
        padding: 1px 20px 20px 20px;
    }

    .Instructors-btn:hover {
        filter: brightness(0.8);
    }

    .Instructors-wrapper
    {
        display:flex;
        flex-wrap: wrap;
    }
    .Instructors-course-item
    {
        padding:10px; 
        margin: 20px;
        background: white;
        width: calc(33% - 60px);
        box-shadow: 1px 1px #ddd;
    }

    .Instructors-course-img-area
    {
        height: 250px; 
        overflow: hidden;
        text-align: center;
        display: flex;
        align-items: flex-end;
    }

    .Instructors-course-max-booking
    {
        margin: 30px 10px 10px 10px;
        overflow:auto;
    }

    .Instructors-course-wrapper
    {
        display:flex;
        flex-wrap: wrap;

    }

    .Instructors-course-img-area i
    {
        display:block;
        padding-top: 40px;
        font-size: 60px;
        background-color:aliceblue;
        height: 100vh;
    }

    img
    {
        width: 100%;
    }

    h4{
        margin-bottom:0px;
        padding:10px;
        width: 50%;
        position: absolute;
        bottom: -20px;
        left: 10px;
    }

    
.ImageGallery-grayscale {
    filter:grayscale(80%);
    transition: ease-out 0.2s;
}

.ImageGallery-no-grayscale {
    filter:grayscale(0%);
    transition: ease-out 0.2s;
}

    @media only screen and (max-width: 1000px) {
        .Instructors-course-img-area {
            height: auto;
            width: auto;
        }
        
        .Instructors-course-item
        {
            padding:10px; 
            margin: 00px 0px 30px 0px;
            width: calc(100% - 20px);
        }       
    }
</style>